import React from 'react';

const ICON_ID = 'icon-profile';

const IconProfile = function(props) {
  return (
    <svg viewBox="0 0 22 26" aria-labelledby={ICON_ID}>
      <title id={ICON_ID}>Profile Icon</title>
      <g fill="none" transform="translate(1, 0)">
        <path d="M9.7218816,0.40008 C6.9570816,0.40008 4.7106816,2.74888 4.7106816,5.63128 C4.7106816,8.51368 6.9570816,10.86248 9.7218816,10.86248 C12.4874496,10.86248 14.7545856,8.51608 14.7545856,5.63128 C14.7545856,2.74648 12.4874496,0.40008 9.7218816,0.40008 Z"></path>
        <path d="M19.104,14.66216 L19.104,23.86216 L0.384,23.86216 L0.384,14.66216 C2.819328,13.56616 6.599424,12.96216 9.732096,12.96216 C12.87552,12.96216 16.664064,13.56056 19.104,14.66216 Z"></path>
      </g>
    </svg>
  )
}

export default IconProfile;



// WEBPACK FOOTER //
// ./src/client/components/icons/icon-profile.jsx